module.exports = __webpack_public_path__ + "static/media/about.f3d8f1cf.png";